/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import Stack from "./ui/Stack";
import Text from "./ui/Text";
import Title from "./ui/Title";
import Anchor from "./ui/Anchor";

const LocationSummary = ({ location }) => {
  if (!location) return null;

  const hasAddress = !!location.full_address;
  const showLink = location.lat && location.lng;

  return (
    <Stack $gap="0.25rem">
      {showLink ? (
        <Anchor underline="always" to={`https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`} target="_blank" rel="noopener noreferrer">
          <Title size="h3" color="link">{location.name}</Title>
        </Anchor>
      ) : (
        <Title size="h3">{location.name}</Title>
      )}
      {hasAddress && (
        <Text size="small">{location.full_address}</Text>
      )}
    </Stack>
  );
};

export default LocationSummary;
